import { Modal } from 'antd-mobile'

const alert = Modal.alert

const typeDict = {
  submit: ['附件未上传成功，是否放弃附件？', '继续等待', '放弃附件'],
  tempLeave: ['此操作将放弃正在上传的文件，是否继续', '取消', '继续操作'],
}

export default async function isLeave(type: LeaveType) {
  return await new Promise<Boolean>((resolve) => {
    const [tip, cancelTxt, confirmTxt] = typeDict[type]

    alert('', tip, [
      {
        text: cancelTxt,
        onPress: () => {
          resolve(false)
        },
      },
      {
        text: confirmTxt,
        onPress: () => {
          resolve(true)
        },
      },
    ])
  })
}
